import { ShieldCheck } from "lucide-react";

import { Panel } from "@/components/panel";

export function ConfigurationScreen() {
  return (
    <main className="grid min-h-screen place-items-center bg-[var(--canvas)] p-6">
      <Panel className="max-w-xl">
        <ShieldCheck className="size-10 text-[var(--teal)]" />
        <h1 className="mt-4 font-serif text-3xl">
          Supabase configuration required
        </h1>
        <p className="mt-2 text-sm leading-6 text-[var(--text-secondary)]">
          Set <code>VITE_SUPABASE_URL</code> and{" "}
          <code>VITE_SUPABASE_PUBLISHABLE_KEY</code> in the Lovable Cloud
          project environment. RAQOZ will not fall back to an embedded
          production database.
        </p>
      </Panel>
    </main>
  );
}
